<div class="match-page-container">
  <h1>CLIN D'OEIL</h1>
  <h2>RECIPROQUE !</h2>
  <div class="match-img">
    @if (users$ | async; as users) {
    <img
      [src]="users.user2.imgUrl | versionedImageUrl : users.user2.profileImageUpdatedAt"
      alt="Profil matché"
    />
    <img
      [src]="users.user1.imgUrl | versionedImageUrl : users.user1.profileImageUpdatedAt"
      alt="Mon profil"
    />
    }
  </div>
  <p>Vous avez désormais 3 heures pour faire connaissance</p>
  <div class="btn-container">
    @if (users$ | async; as users) {
    <button class="btn-match" type="button" (click)="openChat(users.user2)">
      Discuter maintenant
    </button>
    }
    <button class="btn-match" type="button" (click)="goBackToSaloon()">Discuter plus tard</button>
  </div>
</div>
